import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for PWR5C4 (交運單沖銷核准)
// ============================================================

export interface ReverseCandidate {
  fc120_01: string; // 交運單號
  fc120_11: string; // 交運日期
  fc120_12: string; // 客戶代碼
  fc120_13: string; // 交運類別
  fc120_17: string; // 部門代碼
  fc120_18: string; // 幣別
  fc120_19: string; // 匯率
  fc120_20: string; // 金額
  fc120_80: string; // 狀態碼
  fc120_90: string; // 沖銷次數
}

export interface QueryResponse {
  items: ReverseCandidate[];
  total: number;
}

export interface ReverseResponse {
  success: number;
  failed: number;
  errors?: string[];
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const pwr5c4Api = {
  /** Query delivery note candidates eligible for approval reversal */
  async queryCandidates(startNo: string, endNo: string): Promise<QueryResponse> {
    const params: Record<string, string> = {};
    if (startNo.trim()) params['start'] = startNo.trim();
    if (endNo.trim()) params['end'] = endNo.trim();
    const res = await apiClient.get('/api/pwr5c4/candidates', { params });
    return res.data;
  },

  /** Execute batch approval reversal for selected delivery notes */
  async reverse(items: string[]): Promise<ReverseResponse> {
    const res = await apiClient.post('/api/pwr5c4/reverse', { items });
    return res.data;
  },
};
